var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 171.417C136.532 171.417 171.417 136.532 171.417 93.5C171.417 50.4679 136.532 15.5834 93.5 15.5834C50.4678 15.5834 15.5833 50.4679 15.5833 93.5C15.5833 136.532 50.4678 171.417 93.5 171.417Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4,
    stroke: "#F6F6F6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9167 66.0704C77.9167 64.473 79.697 63.5202 81.0261 64.4063L122.171 91.8359C123.358 92.6276 123.358 94.3725 122.171 95.1641L81.0261 122.594C79.697 123.48 77.9167 122.527 77.9167 120.93V66.0704Z",
    fill: "#F6F6F6",
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.acafab81248314cd39997eb337933ed2.svg";
export { ForwardRef as ReactComponent };